import { Controller } from "@hotwired/stimulus"

// Poptávkový wizard — one visible step at a time. Option buttons store
// their value into a hidden form field and advance to the next step.
// The step value pre-opens a step (form re-render with validation errors).
export default class extends Controller {
  static targets = ["step", "field", "nope", "recap"]
  static values = {
    step: String,
    cheapestBudget: String,
    fastestTimeline: String,
    costBudgets: Array,
    fastTimelines: Array,
  }

  connect() {
    this.show(this.stepValue || "start")
  }

  go(event) {
    this.show(event.params.next)
  }

  choose(event) {
    const { field, value, next } = event.params
    const input = this.fieldTargets.find((f) => f.name === `contact[${field}]`)
    if (input) input.value = value
    this.show(next)
  }

  show(name) {
    this.stepTargets.forEach((step) => {
      step.hidden = step.dataset.step !== name
    })
    if (name === "detail") {
      this.checkCombo()
      this.buildRecap()
    }
  }

  // „Levně + rychle + pořádně" naráz: nejlevnější rozpočet a zároveň nejdříve = chce všechny tři.
  // Ukáže smířlivé upozornění s odkazem na článek. Formulář zůstává odeslatelný.
  checkCombo() {
    if (!this.hasNopeTarget) return
    const impossible =
      this.fieldValue("budget") === this.cheapestBudgetValue &&
      this.fieldValue("timeline") === this.fastestTimelineValue
    this.nopeTarget.hidden = !impossible
    // The budget and timeline note lives inside the recap. On this combo it
    // replaces the normal verdict so the same thing isn't shown twice.
    if (this.hasRecapTarget) this.recapVerdict.hidden = impossible
  }

  // Shrnutí výběru + zařazení do dvojice z trojúhelníku rychle/levně/pořádně.
  // Pořádně děláme vždy; druhá kategorie = levně (úsporný rozpočet) nebo rychle (rozpočet stačí).
  buildRecap() {
    if (!this.hasRecapTarget) return
    const type = this.fieldValue("project_type")
    const budget = this.fieldValue("budget")
    const timeline = this.fieldValue("timeline")

    if (!type && !budget && !timeline) {
      this.recapTarget.hidden = true
      return
    }

    const parts = []
    if (type) parts.push(type)
    if (timeline) parts.push(this.timelinePhrase(timeline))
    if (budget && budget !== "Zatím nevím") {
      parts.push(budget === this.cheapestBudgetValue ? "s důrazem na nízké náklady" : `s rozpočtem ${this.lower(budget)}`)
    }
    const summary = parts.join(" ")

    this.recapSummary.textContent = summary ? `${summary}.` : ""
    this.recapVerdict.innerHTML = this.verdict(budget, timeline)
    this.recapTarget.hidden = false
  }

  verdict(budget, timeline) {
    const cheapest = budget === this.cheapestBudgetValue
    const fastest = timeline === this.fastestTimelineValue
    if (cheapest && fastest) {
      return "Při nízkém rozpočtu a krátkém termínu společně upřesníme <strong>rozsah a priority</strong> projektu."
    }

    let second
    if (budget && budget !== "Zatím nevím") {
      second = this.costBudgetsValue.includes(budget) ? "rozpočet" : "termín"
    } else if (timeline) {
      second = this.fastTimelinesValue.includes(timeline) ? "termín" : "rozpočet"
    } else {
      return "Společně upřesníme <strong>rozsah, termín a cenu</strong> projektu."
    }
    return `Při návrhu řešení zohledníme váš <strong>${second}</strong>. Konkrétní rozsah a postup s vámi projdeme.`
  }

  timelinePhrase(t) {
    if (t === "Termín neřeším") return "bez pevného termínu"
    return this.lower(t)
  }

  lower(s) {
    return s ? s.charAt(0).toLowerCase() + s.slice(1) : s
  }

  get recapSummary() {
    return this.recapTarget.querySelector('[data-recap="summary"]')
  }

  get recapVerdict() {
    return this.recapTarget.querySelector('[data-recap="verdict"]')
  }

  fieldValue(field) {
    const input = this.fieldTargets.find((f) => f.name === `contact[${field}]`)
    return input ? input.value : ""
  }
}
